import gql from 'graphql-tag';

export const GET_BBL_CONSTANTS = gql`
  query {
    calculationConstants(where: { name: { eq: "BblYield" } }) {
      value
    }
  }
`